/**
 * @generated SignedSource<<849bc40838766e402ff194654a89d55f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type PROJECT_STATUS = "OPPORTUNITY" | "PLANNING" | "RUNNING" | "HALTED" | "DONE" | "%future added value";
export type STATUS_CATEGORY = "TODO" | "INPROGRESS" | "DONE" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type MyWorkTasksSection_viewer$data = {
  readonly id: string;
  readonly actualPersonId: string | null;
  readonly harvestUser: boolean | null;
  readonly unit4User: boolean | null;
  readonly excludeFromCompanyLockedPeriod: boolean | null;
  readonly submitLockedDateYear: number | null;
  readonly submitLockedDateMonth: number | null;
  readonly submitLockedDateDay: number | null;
  readonly availableFeatureFlags: ReadonlyArray<{
    readonly key: string | null;
  } | null> | null;
  readonly startDate: string | null;
  readonly endDate: string | null;
  readonly createdAt: string | null;
  readonly monday: number | null;
  readonly tuesday: number | null;
  readonly wednesday: number | null;
  readonly thursday: number | null;
  readonly friday: number | null;
  readonly saturday: number | null;
  readonly sunday: number | null;
  readonly email: string | null;
  readonly timerStartDate: string | null;
  readonly timerTask: {
    readonly id: string;
  } | null;
  readonly company: {
    readonly id: string;
    readonly harvestEnabled: boolean | null;
    readonly unit4Enabled: boolean | null;
    readonly lockedPeriodYear: number | null;
    readonly lockedPeriodMonth: number | null;
    readonly lockedPeriodDay: number | null;
    readonly modules: ReadonlyArray<{
      readonly moduleType: string | null;
    } | null> | null;
    readonly roles: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly name: string | null;
        } | null;
      } | null> | null;
    } | null;
    readonly teams: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly name: string | null;
          readonly teamPersons: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly id: string;
                readonly person: {
                  readonly id: string;
                } | null;
              } | null;
            } | null> | null;
          } | null;
        } | null;
      } | null> | null;
    } | null;
    readonly allTasks: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly fullAccessToProject: boolean | null;
          readonly sortOrder: number | null;
          readonly readOnly: {
            readonly isReadOnly: boolean | null;
          } | null;
          readonly statusColumnV2: {
            readonly id: string;
            readonly name: string | null;
            readonly category: STATUS_CATEGORY | null;
          } | null;
          readonly companyTaskId: number | null;
          readonly name: string | null;
          readonly latestUiUpdateAt: string | null;
          readonly subTaskCount: number | null;
          readonly startDay: number | null;
          readonly startMonth: number | null;
          readonly startYear: number | null;
          readonly deadlineDay: number | null;
          readonly deadlineMonth: number | null;
          readonly deadlineYear: number | null;
          readonly bug: boolean | null;
          readonly blocked: boolean | null;
          readonly highPriority: boolean | null;
          readonly hasChildren: boolean | null;
          readonly billable: boolean | null;
          readonly sageIntacctId: string | null;
          readonly favoured: boolean | null;
          readonly hasDependency: boolean | null;
          readonly project: {
            readonly id: string;
            readonly stage: {
              readonly id: string;
              readonly name: string | null;
              readonly profile: PROJECT_STATUS | null;
            } | null;
            readonly companyProjectId: number | null;
            readonly projectColor: string | null;
            readonly projectGroupId: string | null;
            readonly name: string | null;
            readonly client: {
              readonly id: string;
              readonly name: string;
            } | null;
          } | null;
          readonly taskLabels: ReadonlyArray<{
            readonly label: {
              readonly id: string;
              readonly name: string | null;
              readonly color: string | null;
            } | null;
          } | null> | null;
          readonly assignedPersons: ReadonlyArray<{
            readonly id: string;
          } | null> | null;
          readonly phase: {
            readonly id: string;
            readonly name: string | null;
            readonly deadlineDay: number | null;
            readonly deadlineMonth: number | null;
            readonly deadlineYear: number | null;
            readonly startDay: number | null;
            readonly startMonth: number | null;
            readonly startYear: number | null;
          } | null;
          readonly sprint: {
            readonly id: string;
            readonly endDay: number | null;
            readonly endMonth: number | null;
            readonly endYear: number | null;
            readonly startDay: number | null;
            readonly startMonth: number | null;
            readonly startYear: number | null;
            readonly name: string | null;
            readonly isProjectGroupSprint: boolean | null;
            readonly projectGroupSprintId: string | null;
          } | null;
          readonly owner: {
            readonly id: string;
          } | null;
          readonly followers: ReadonlyArray<{
            readonly id: string;
          } | null> | null;
          readonly " $fragmentSpreads": FragmentRefs<"TaskRow_task">;
        } | null;
      } | null> | null;
    } | null;
    readonly noDatesTasks: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly fullAccessToProject: boolean | null;
          readonly sortOrder: number | null;
          readonly readOnly: {
            readonly isReadOnly: boolean | null;
          } | null;
          readonly companyTaskId: number | null;
          readonly name: string | null;
          readonly latestUiUpdateAt: string | null;
          readonly subTaskCount: number | null;
          readonly startDay: number | null;
          readonly startMonth: number | null;
          readonly startYear: number | null;
          readonly deadlineDay: number | null;
          readonly deadlineMonth: number | null;
          readonly deadlineYear: number | null;
          readonly bug: boolean | null;
          readonly blocked: boolean | null;
          readonly highPriority: boolean | null;
          readonly billable: boolean | null;
          readonly favoured: boolean | null;
          readonly hasDependency: boolean | null;
          readonly project: {
            readonly id: string;
            readonly stage: {
              readonly id: string;
              readonly name: string | null;
              readonly profile: PROJECT_STATUS | null;
            } | null;
            readonly companyProjectId: number | null;
            readonly name: string | null;
            readonly client: {
              readonly id: string;
              readonly name: string;
            } | null;
          } | null;
          readonly statusColumnV2: {
            readonly id: string;
            readonly name: string | null;
            readonly category: STATUS_CATEGORY | null;
          } | null;
          readonly taskLabels: ReadonlyArray<{
            readonly label: {
              readonly id: string;
              readonly name: string | null;
              readonly color: string | null;
            } | null;
          } | null> | null;
          readonly assignedPersons: ReadonlyArray<{
            readonly id: string;
          } | null> | null;
          readonly phase: {
            readonly id: string;
            readonly name: string | null;
            readonly deadlineDay: number | null;
            readonly deadlineMonth: number | null;
            readonly deadlineYear: number | null;
            readonly startDay: number | null;
            readonly startMonth: number | null;
            readonly startYear: number | null;
          } | null;
          readonly timeRegistrations: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly id: string;
                readonly minutesRegistered: number | null;
              } | null;
            } | null> | null;
          } | null;
          readonly sprint: {
            readonly id: string;
            readonly endDay: number | null;
            readonly endMonth: number | null;
            readonly endYear: number | null;
            readonly startDay: number | null;
            readonly startMonth: number | null;
            readonly startYear: number | null;
          } | null;
          readonly owner: {
            readonly id: string;
          } | null;
          readonly followers: ReadonlyArray<{
            readonly id: string;
          } | null> | null;
          readonly " $fragmentSpreads": FragmentRefs<"TaskRow_task">;
        } | null;
      } | null> | null;
    } | null;
    readonly doneTasks: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly fullAccessToProject: boolean | null;
          readonly sortOrder: number | null;
          readonly readOnly: {
            readonly isReadOnly: boolean | null;
          } | null;
          readonly companyTaskId: number | null;
          readonly name: string | null;
          readonly latestUiUpdateAt: string | null;
          readonly subTaskCount: number | null;
          readonly startDay: number | null;
          readonly startMonth: number | null;
          readonly startYear: number | null;
          readonly deadlineDay: number | null;
          readonly deadlineMonth: number | null;
          readonly deadlineYear: number | null;
          readonly bug: boolean | null;
          readonly blocked: boolean | null;
          readonly highPriority: boolean | null;
          readonly billable: boolean | null;
          readonly favoured: boolean | null;
          readonly hasDependency: boolean | null;
          readonly project: {
            readonly id: string;
            readonly stage: {
              readonly id: string;
              readonly name: string | null;
              readonly profile: PROJECT_STATUS | null;
            } | null;
            readonly companyProjectId: number | null;
            readonly name: string | null;
            readonly client: {
              readonly id: string;
              readonly name: string;
            } | null;
          } | null;
          readonly statusColumnV2: {
            readonly id: string;
            readonly name: string | null;
            readonly category: STATUS_CATEGORY | null;
          } | null;
          readonly taskLabels: ReadonlyArray<{
            readonly label: {
              readonly id: string;
              readonly name: string | null;
              readonly color: string | null;
            } | null;
          } | null> | null;
          readonly assignedPersons: ReadonlyArray<{
            readonly id: string;
          } | null> | null;
          readonly phase: {
            readonly id: string;
            readonly name: string | null;
            readonly deadlineDay: number | null;
            readonly deadlineMonth: number | null;
            readonly deadlineYear: number | null;
            readonly startDay: number | null;
            readonly startMonth: number | null;
            readonly startYear: number | null;
          } | null;
          readonly timeRegistrations: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly id: string;
                readonly minutesRegistered: number | null;
              } | null;
            } | null> | null;
          } | null;
          readonly sprint: {
            readonly id: string;
            readonly endDay: number | null;
            readonly endMonth: number | null;
            readonly endYear: number | null;
            readonly startDay: number | null;
            readonly startMonth: number | null;
            readonly startYear: number | null;
          } | null;
          readonly owner: {
            readonly id: string;
          } | null;
          readonly followers: ReadonlyArray<{
            readonly id: string;
          } | null> | null;
          readonly " $fragmentSpreads": FragmentRefs<"TaskRow_task">;
        } | null;
      } | null> | null;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"genericTaskContextMenu_company">;
  } | null;
  readonly " $fragmentType": "MyWorkTasksSection_viewer";
};
export type MyWorkTasksSection_viewer$key = {
  readonly " $data"?: MyWorkTasksSection_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"MyWorkTasksSection_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  (v0/*: any*/)
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = [
  (v0/*: any*/),
  (v2/*: any*/)
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v7 = {
  "args": [
    {
      "kind": "Variable",
      "name": "personId",
      "variableName": "personId"
    }
  ],
  "kind": "FragmentSpread",
  "name": "TaskRow_task"
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullAccessToProject",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sortOrder",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "TaskReadOnly",
  "kind": "LinkedField",
  "name": "readOnly",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isReadOnly",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "StatusColumnV2",
  "kind": "LinkedField",
  "name": "statusColumnV2",
  "plural": false,
  "selections": [
    (v0/*: any*/),
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "category",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "companyTaskId",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "latestUiUpdateAt",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "subTaskCount",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startDay",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startMonth",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startYear",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deadlineDay",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deadlineMonth",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deadlineYear",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "bug",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "blocked",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "highPriority",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "billable",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "favoured",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasDependency",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "stage",
  "plural": false,
  "selections": [
    (v0/*: any*/),
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "profile",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "companyProjectId",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "concreteType": "Client",
  "kind": "LinkedField",
  "name": "client",
  "plural": false,
  "selections": (v3/*: any*/),
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "concreteType": "TaskLabel",
  "kind": "LinkedField",
  "name": "taskLabels",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Label",
      "kind": "LinkedField",
      "name": "label",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "color",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "concreteType": "Person",
  "kind": "LinkedField",
  "name": "assignedPersons",
  "plural": true,
  "selections": (v1/*: any*/),
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "concreteType": "PhaseType",
  "kind": "LinkedField",
  "name": "phase",
  "plural": false,
  "selections": [
    (v0/*: any*/),
    (v2/*: any*/),
    (v18/*: any*/),
    (v19/*: any*/),
    (v20/*: any*/),
    (v15/*: any*/),
    (v16/*: any*/),
    (v17/*: any*/)
  ],
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endDay",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endMonth",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endYear",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "concreteType": "Person",
  "kind": "LinkedField",
  "name": "owner",
  "plural": false,
  "selections": (v1/*: any*/),
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "concreteType": "Person",
  "kind": "LinkedField",
  "name": "followers",
  "plural": true,
  "selections": (v1/*: any*/),
  "storageKey": null
},
v38 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "TaskTypeEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Task",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v7/*: any*/),
          (v0/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v12/*: any*/),
          (v2/*: any*/),
          (v13/*: any*/),
          (v14/*: any*/),
          (v15/*: any*/),
          (v16/*: any*/),
          (v17/*: any*/),
          (v18/*: any*/),
          (v19/*: any*/),
          (v20/*: any*/),
          (v21/*: any*/),
          (v22/*: any*/),
          (v23/*: any*/),
          (v24/*: any*/),
          (v25/*: any*/),
          (v26/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              (v27/*: any*/),
              (v28/*: any*/),
              (v2/*: any*/),
              (v29/*: any*/)
            ],
            "storageKey": null
          },
          (v11/*: any*/),
          (v30/*: any*/),
          (v31/*: any*/),
          (v32/*: any*/),
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 1000000
              }
            ],
            "concreteType": "TimeRegTypeConnection",
            "kind": "LinkedField",
            "name": "timeRegistrations",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "TimeRegTypeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TimeRegType",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v0/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "minutesRegistered",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "timeRegistrations(first:1000000)"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Sprint",
            "kind": "LinkedField",
            "name": "sprint",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              (v33/*: any*/),
              (v34/*: any*/),
              (v35/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/)
            ],
            "storageKey": null
          },
          (v36/*: any*/),
          (v37/*: any*/),
          (v4/*: any*/)
        ],
        "storageKey": null
      },
      (v5/*: any*/)
    ],
    "storageKey": null
  },
  (v6/*: any*/)
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "doneTasksSearchQuery"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "noDatesSearchQuery"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "personId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "searchQuery"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": null
      },
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "company",
          "teams"
        ]
      },
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "company",
          "allTasks"
        ]
      },
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "company",
          "noDatesTasks"
        ]
      },
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "company",
          "doneTasks"
        ]
      }
    ]
  },
  "name": "MyWorkTasksSection_viewer",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "actualPersonId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "harvestUser",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "unit4User",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "excludeFromCompanyLockedPeriod",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "submitLockedDateYear",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "submitLockedDateMonth",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "submitLockedDateDay",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FeatureFlag",
      "kind": "LinkedField",
      "name": "availableFeatureFlags",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "key",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "monday",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tuesday",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "wednesday",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "thursday",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "friday",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "saturday",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sunday",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "timerStartDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Task",
      "kind": "LinkedField",
      "name": "timerTask",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "genericTaskContextMenu_company"
        },
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "harvestEnabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "unit4Enabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lockedPeriodYear",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lockedPeriodMonth",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lockedPeriodDay",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Module",
          "kind": "LinkedField",
          "name": "modules",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "moduleType",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "RoleTypeConnection",
          "kind": "LinkedField",
          "name": "roles",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "RoleTypeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Role",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": (v3/*: any*/),
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": "teams",
          "args": null,
          "concreteType": "TeamTypeConnection",
          "kind": "LinkedField",
          "name": "__Company_teams_connection",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "TeamTypeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Team",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    (v2/*: any*/),
                    {
                      "alias": "teamPersons",
                      "args": null,
                      "concreteType": "TeamPersonTypeConnection",
                      "kind": "LinkedField",
                      "name": "__Team_teamPersons_connection",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "TeamPersonTypeEdge",
                          "kind": "LinkedField",
                          "name": "edges",
                          "plural": true,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "TeamPerson",
                              "kind": "LinkedField",
                              "name": "node",
                              "plural": false,
                              "selections": [
                                (v0/*: any*/),
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": "Person",
                                  "kind": "LinkedField",
                                  "name": "person",
                                  "plural": false,
                                  "selections": (v1/*: any*/),
                                  "storageKey": null
                                },
                                (v4/*: any*/)
                              ],
                              "storageKey": null
                            },
                            (v5/*: any*/)
                          ],
                          "storageKey": null
                        },
                        (v6/*: any*/)
                      ],
                      "storageKey": null
                    },
                    (v4/*: any*/)
                  ],
                  "storageKey": null
                },
                (v5/*: any*/)
              ],
              "storageKey": null
            },
            (v6/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": "allTasks",
          "args": null,
          "concreteType": "TaskTypeConnection",
          "kind": "LinkedField",
          "name": "__Company_allTasks_connection",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "TaskTypeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Task",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v7/*: any*/),
                    (v0/*: any*/),
                    (v8/*: any*/),
                    (v9/*: any*/),
                    (v10/*: any*/),
                    (v11/*: any*/),
                    (v12/*: any*/),
                    (v2/*: any*/),
                    (v13/*: any*/),
                    (v14/*: any*/),
                    (v15/*: any*/),
                    (v16/*: any*/),
                    (v17/*: any*/),
                    (v18/*: any*/),
                    (v19/*: any*/),
                    (v20/*: any*/),
                    (v21/*: any*/),
                    (v22/*: any*/),
                    (v23/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hasChildren",
                      "storageKey": null
                    },
                    (v24/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "sageIntacctId",
                      "storageKey": null
                    },
                    (v25/*: any*/),
                    (v26/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "ProjectType",
                      "kind": "LinkedField",
                      "name": "project",
                      "plural": false,
                      "selections": [
                        (v0/*: any*/),
                        (v27/*: any*/),
                        (v28/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "projectColor",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "projectGroupId",
                          "storageKey": null
                        },
                        (v2/*: any*/),
                        (v29/*: any*/)
                      ],
                      "storageKey": null
                    },
                    (v30/*: any*/),
                    (v31/*: any*/),
                    (v32/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Sprint",
                      "kind": "LinkedField",
                      "name": "sprint",
                      "plural": false,
                      "selections": [
                        (v0/*: any*/),
                        (v33/*: any*/),
                        (v34/*: any*/),
                        (v35/*: any*/),
                        (v15/*: any*/),
                        (v16/*: any*/),
                        (v17/*: any*/),
                        (v2/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "isProjectGroupSprint",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "projectGroupSprintId",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    (v36/*: any*/),
                    (v37/*: any*/),
                    (v4/*: any*/)
                  ],
                  "storageKey": null
                },
                (v5/*: any*/)
              ],
              "storageKey": null
            },
            (v6/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": "noDatesTasks",
          "args": null,
          "concreteType": "TaskTypeConnection",
          "kind": "LinkedField",
          "name": "__Company_noDatesTasks_connection",
          "plural": false,
          "selections": (v38/*: any*/),
          "storageKey": null
        },
        {
          "alias": "doneTasks",
          "args": null,
          "concreteType": "TaskTypeConnection",
          "kind": "LinkedField",
          "name": "__Company_doneTasks_connection",
          "plural": false,
          "selections": (v38/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "e7c2c564c18f0876a3bb818437bc76d5";

export default node;
